import React, { useState, useEffect } from 'react';
import { ArrowSmallLeftIcon } from '@heroicons/react/24/outline'
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

export default function AddEmployee({ token }) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [employeeData, setEmployeeData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  });

  useEffect(() => {
    // 
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEmployeeData((prevData) => ({ ...prevData, [name]: value }));
    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const formData = new FormData()
      Object.keys(employeeData).map(key => {
        formData.append(key, employeeData[key])
      })

      const response = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
        method: 'POST',
        headers: {
          'access-token': token
        },
        body: formData,
      });

      if (response.ok) {
        // Employee creation successful
        toast.success('Employee created successfully');
        navigate('/employees')
      } else if (response.status >= 400 && response.status < 500) {
        // Employee creation failed due to validation errors
        const errorData = await response.json();
        setValidationErrors(errorData);
        toast.error('Failed to create employee');
      } else {
        // Other error occurred
        toast.error('Failed to create employee');
      }
    } catch (error) {
      console.error('Error creating employee:', error);
      toast.error('An error occurred');
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="flex justify-center items-center relative">
      <div className="bg-white p-8 rounded-lg shadow-lg w-2/3">
        <h2 className="text-primary-500 text-2xl font-bold mb-4 flex items-center ">
          <Link to="/employees" className='cursor-pointer'>
            <ArrowSmallLeftIcon className='h-6 w-6 text-primary-500 mr-4 rounded-full border hover:border-primary-500' />
          </Link>
          New Employee
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block mb-2 text-primary-500">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              required={true}
              value={employeeData.name}
              onChange={handleInputChange}
              className="border-b border-primary-500 px-2 py-1 w-80 outline-0"
            />
            <p className='py-2 text-red-500 mt-2 rounded'>
              {validationErrors?.name && <span className="text-red-500">{validationErrors.name}</span>}
            </p>
          </div>

          <div className="mb-4">
            <label htmlFor="email" className="block mb-2 text-primary-500">
              Email
            </label>
            <input
              type="email"
              id="email"
              required={true}
              name="email"
              value={employeeData.email}
              onChange={handleInputChange}
              className="border-b border-primary-500 px-2 py-1 w-80 outline-0"
            />
            <p className='py-2 text-red-500 mt-2 rounded'>
              {validationErrors?.email && <span className="text-red-500">{validationErrors.email}</span>}
            </p>
          </div>

          <div className="mb-4">
            <label htmlFor="phone" className="block mb-2 text-primary-500">
              Phone
            </label>
            <input
              type="text"
              id="phone"
              required={true}
              name="phone"
              value={employeeData.phone}
              onChange={handleInputChange}
              className="border-b border-primary-500 px-2 py-1 w-80 outline-0"
            />
            <p className='py-2 text-red-500 mt-2 rounded'>
              {validationErrors?.phone && <span className="text-red-500">{validationErrors.phone}</span>}
            </p>
          </div>

          <div className="mb-4">
            <label htmlFor="phone" className="block mb-2 text-primary-500">
              Password
            </label>
            <input
              type="password"
              id="password"
              required={true}
              name="password"
              value={employeeData.password}
              onChange={handleInputChange}
              className="border-b border-primary-500 px-2 py-1 w-80 outline-0"
            />
            <p className='py-2 text-red-500 mt-2 rounded'>
              {validationErrors?.password && <span className="text-red-500">{validationErrors.password}</span>}
            </p>
          </div>


          <button
            type="submit"
            className="bg-primary-500 text-white px-4 py-2 rounded-full transition-all border border-white ring-primary-500 hover:bg-primary-500 hover:ring-2"
            disabled={isLoading} // Disable the button when isLoading is true
          >
            {isLoading ? '...' : 'Create'}
          </button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );

}
